import React from 'react'

export default function ({data}) {
  const keys = Object.keys(data)
  return (
    <div className='calloutData'>
      <table>
        <tbody>
          {
            keys.map((item, index) => {
              return (
                <tr key={index}>
                  <th>{item}</th>
                  <td>{data[item]}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  )
}
